import type { PaymentsStore } from './interfaces'

import { isFullArray } from '@helpers/array'

export const getters = {
  isPaymentMethodsLoading: (state: PaymentsStore): PaymentsStore['paymentMethodsLoading'] => state.paymentMethodsLoading,
  isLoading: (state: PaymentsStore): PaymentsStore['loading'] => state.loading,
  isPaymentMethodsListLoading: (state: PaymentsStore): PaymentsStore['paymentMethodsListLoading'] => state.paymentMethodsListLoading,
  getPaymentMethods: (state: PaymentsStore): PaymentsStore['paymentMethods'] => {
    const defaultItem = state.paymentMethods.find(item => item.is_default)

    if (!defaultItem) {
      return state.paymentMethods
    } else {
      return [
        defaultItem,
        ...state.paymentMethods.filter(item => item !== defaultItem),
      ]
    }
  },
  isPaymentMethods: (state: PaymentsStore): boolean => isFullArray(state.paymentMethods),
  isSubscriptionsLoading: (state: PaymentsStore): PaymentsStore['subscriptionsLoading'] => state.subscriptionsLoading,
  getSubscriptions: (state: PaymentsStore): PaymentsStore['subscriptions'] => state.subscriptions,
  isSubscriptions: (state: PaymentsStore): boolean => isFullArray(state.subscriptions),
  getModalChangeDefaultCreditCard: (state: PaymentsStore): PaymentsStore['modalChangeDefaultCreditCard'] => state.modalChangeDefaultCreditCard,
  isModalChangeDefaultCreditCard: (state: PaymentsStore): boolean => !!state.modalChangeDefaultCreditCard?.id || false,
  getModalDeleteCreditCard: (state: PaymentsStore): PaymentsStore['modalDeleteCreditCard'] => state.modalDeleteCreditCard,
  isModalDeleteCreditCard: (state: PaymentsStore): boolean => !!state.modalDeleteCreditCard?.id || false,
  isModalAddCreditCard: (state: PaymentsStore): PaymentsStore['modalAddCreditCard'] => state.modalAddCreditCard,
  getMerchantData: (state: PaymentsStore): PaymentsStore['merchantData'] => state.merchantData,
  isMerchantData: (state: PaymentsStore): boolean => !!state.merchantData,
  getStripeSetupSecret: (state: PaymentsStore): PaymentsStore['stripeSetupSecret'] => state.stripeSetupSecret,
  isStripeSetupSecret: (state: PaymentsStore): boolean => !!state.stripeSetupSecret,
  getModalRefund: (state: PaymentsStore): PaymentsStore['modalRefund'] => state.modalRefund,
  isModalRefund: (state: PaymentsStore): boolean => !!state.modalRefund?.id,
}
